











































































































































import { Component, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
@Component
export default class BargainData extends Vue {
  is_loading: boolean = false;
  is_show_count_modal: boolean = false;
}
